// DataSourceIcon.jsx

import React from "react";
import { Box, Tooltip, Typography, Divider, Stack } from "@mui/material";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";

const DataSourceIcon = ({
  mode = "light", // "light" | "dark"
  title = "Data Sources",
  sources = [], // string[] OR structured later
  webSearchProviders = ["Reuters", "CNN", "Other News Agencies"],
}) => {
  const isDark = mode === "dark";

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.8rem",
              mb: 0.5,
              color: "white",
            }}
          >
            {title}
          </Typography>

          <Divider sx={{ mb: 0.8 }} />

          <Stack spacing={0.4}>
            {sources.map((src, idx) => (
              <Typography
                key={idx}
                sx={{
                  fontSize: "0.78rem",
                  lineHeight: 1.3,
                  color: "white",
                }}
              >
                •{" "}
                {src === "Web Search"
                  ? `Web Search (${webSearchProviders.join(",")})`
                  : src}
              </Typography>
            ))}
          </Stack>
        </Box>
      }
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "999px",
          p: 0.55,
          cursor: "help",
          bgcolor: isDark ? "rgba(255,255,255,0.14)" : "rgba(15,23,42,0.06)",
          border: isDark
            ? "1px solid rgba(255,255,255,0.5)"
            : "1px solid rgba(15,23,42,0.18)",
        }}
      >
        <SourceOutlinedIcon
          sx={{
            fontSize: "1rem",
            color: isDark ? "#ffffff" : "#0f172a",
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default DataSourceIcon;
